module.exports = __webpack_public_path__ + "assets/img/jlj-qj.72fdd489.png";